import { render, staticRenderFns } from "./LearningrecordsList.vue?vue&type=template&id=7ec9581c"
import script from "./LearningrecordsList.vue?vue&type=script&lang=js"
export * from "./LearningrecordsList.vue?vue&type=script&lang=js"
import style0 from "./LearningrecordsList.vue?vue&type=style&index=0&id=7ec9581c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports